import React from "react";


const ConfirmCaseDetails = ({ formData }) => (
  <div className="row">
    <div className="col-xs-12">
      <h4 className="bold">Confirm Details Entered</h4>
      <p className="alert alert-info">
        Kindly review all information entered before proceeding
      </p>
      
    </div>
  </div>
);

export default ConfirmCaseDetails;



// WEBPACK FOOTER //
// ./src/components/discover/newCase/transactionDetail/CreateCaseForms/Confirmation.js